import { ArchiveCatalogNameSeqType } from './archive-catalog-name-seq-type.enum';
import { ArchiveCatalogNameDynamicType } from './archive-catalog-name-dynamic-type.enum';
import { RecordBase } from '../../providers/request/record-base.model';
export class ArchiveCatalogNameRule extends RecordBase {
  catalogId?: number;
  seqFixedPrefix?: string;
  seqType?: ArchiveCatalogNameSeqType = ArchiveCatalogNameSeqType.NONE;
  seqFixedSuffix?: string;
  dynamicNameType?: ArchiveCatalogNameDynamicType =
    ArchiveCatalogNameDynamicType.NONE;
  staticName?: string;
  example?: string;
}
